import { useMutation } from "react-query";

import { CreateCorporationBody } from "doxecure-commons/lib/doxecureClientTypes";

import { createCorporation } from "@services/corporations.service";

const useCreateCorporation = () => useMutation((values: CreateCorporationBody) => createCorporation(values));

export default useCreateCorporation;
